import type { It4Response } from "@/shared/api";

import { stagePost } from "@/shared/api";

export interface DeviceModel {
    name: string;
    model_id: string;
    brand_id: string;
    category_id: string;
}

/** Получить модели бренда в категории */
export async function getDeviceModels(payload: {
    token: string;
    brand_id: string;
    category_id: string;
}): Promise<DeviceModel[]> {
    const response = await stagePost<It4Response<DeviceModel[]>>(
        "/api/tin/v1/site/quest/calc/models",
        payload,
    );
    return response.data;
}
